/**
 * How a client came to the premise, written once by the path that created the client row (docs/clients.md, _Where a
 * client came from_). A client whose row predates it, and that the backfill could not place, has none (`null`).
 */
export enum CustomerSource {
  /** The public reservation widget. */
  PublicReservation = 'public_reservation',
  /** The public event sign-up. */
  PublicEvent = 'public_event',
  /** Added by a member of staff; who it was is `createdBy`. */
  Manual = 'manual',
  /** The person joined the premise themself, signed in. */
  ClientZone = 'client_zone',
}
